import {
    USERS_PAGE_LIST_REQUEST,
    USERS_PAGE_LIST_RESPONSE,
    USER_ADD_NEW,
    USER_APPLY_FILTER_CRITERIA,
    USER_APPLY_MODEL_UPDATE,
    USER_CANCEL_MODEL_UPDATE,
    USER_CLEAR_FILTER_CRITERIA,
    USER_ITEM_CACHED_RESPONSE,
    USER_ITEM_ERROR_RESPONSE,
    USER_ITEM_REQUEST,
    USER_ITEM_RESPONSE,
    USER_ITEM_SAVE_REQUEST,
    USER_ITEM_SAVE_RESPONSE,
    USER_LIST_CACHED_RESPONSE,
    USER_LIST_ERROR_RESPONSE,
    USER_LIST_REQUEST,
    USER_LIST_RESPONSE,
    USER_LIST_SEARCH_REQUEST,
    USER_SET_EDIT_MODE,
    USER_SET_FILTER,
    USER_UPDATE_FILTER_CRITERIA,
    USER_UPDATE_IMAGE,
    USER_UPDATE_MODEL
} from "./action-types"
import {
    itemRequest,
    setFilter,
    setEditMode,
    updateFilterCriteria,
    clearFilterCriteria,
    applyFilterCriteria,
    updateModel,
    applyModelUpdate,
    cancelModelUpdate,
    defaultAction,
    updateImage,
    listSearchRequest,
    listPageRequest
} from "./default-actions/presentation-actions"
import {
    itemResponse,
    itemSaveRequest,
    itemCachedResponse,
    itemErrorResponse
} from "./default-actions/entity-actions"
import {
    listRequest,
    listResponse,
    listCachedResponse,
    listErrorResponse,
    listInvalidationRequest
} from "./default-actions/paging-actions"

// Users Paging Actions

export const userListRequest = listRequest(USER_LIST_REQUEST)
export const userListSearchRequest = listSearchRequest(USER_LIST_SEARCH_REQUEST)
export const userListInvalidationRequest = listInvalidationRequest(
    USER_LIST_REQUEST
)
export const userListResponse = listResponse(USER_LIST_RESPONSE)
export const userListCachedResponse = listCachedResponse(
    USER_LIST_CACHED_RESPONSE
)
export const userListErrorResponse = listErrorResponse(USER_LIST_ERROR_RESPONSE)

// Actions specific to Users page
const usersPageListResponse = listResponse(USERS_PAGE_LIST_RESPONSE)
export const usersPageListRequest = listPageRequest(
    USERS_PAGE_LIST_REQUEST,
    usersPageListResponse
)

// Entity Actions
export const userItemRequest = itemRequest(USER_ITEM_REQUEST)
export const userItemResponse = itemResponse(USER_ITEM_RESPONSE)
export const userItemCachedResponse = itemCachedResponse(
    USER_ITEM_CACHED_RESPONSE
)
export const userItemErrorResponse = itemErrorResponse(USER_ITEM_ERROR_RESPONSE)
export const userItemSaveRequest = itemSaveRequest(USER_ITEM_SAVE_REQUEST)
export const userItemSaveResponse = itemResponse(USER_ITEM_SAVE_RESPONSE)

// Presentation Actions
export const userSetFilter = setFilter(USER_SET_FILTER)
export const userSetEditMode = setEditMode(USER_SET_EDIT_MODE)
export const userUpdateFilterCriteria = updateFilterCriteria(
    USER_UPDATE_FILTER_CRITERIA
)
export const userClearFilterCriteria = clearFilterCriteria(
    USER_CLEAR_FILTER_CRITERIA
)
export const userApplyFilterCriteria = applyFilterCriteria(
    USER_APPLY_FILTER_CRITERIA
)
export const userUpdateModel = updateModel(USER_UPDATE_MODEL)
export const userUpdateImage = updateImage(USER_UPDATE_IMAGE)
export const userApplyModelUpdate = applyModelUpdate(USER_APPLY_MODEL_UPDATE)
export const userCancelModelUpdate = cancelModelUpdate(USER_CANCEL_MODEL_UPDATE)
export const userAddNew = defaultAction(USER_ADD_NEW)
